import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { ExperienceCategory, ExperienceType, ExperienceMode } from '@/generated/graphql';
import {
  EXPLORE_FILTER_CATEGORY,
  EXPLORE_FILTER_TIME,
  EXPLORE_FILTER_TYPE,
  EXPLORE_FILTER_MODE,
  EXPLORE_FILTER_TAG,
  TimeFilter,
  EXPLORE_FILTER_LOCALITY,
} from './use-experience-filter';

export type TypeKey = typeof EXPLORE_FILTER_TYPE;
export type CategoryKey = typeof EXPLORE_FILTER_CATEGORY;
export type TimeKey = typeof EXPLORE_FILTER_TIME;
export type ModeKey = typeof EXPLORE_FILTER_MODE;
export type LocalityKey = typeof EXPLORE_FILTER_LOCALITY;
export type TagKey = typeof EXPLORE_FILTER_TAG;

type FilterKeys = TypeKey | CategoryKey | TimeKey | ModeKey | LocalityKey | TagKey | undefined;

const useSetFilter = <FilterKey extends FilterKeys>(key: FilterKeys) => {
  type FilterValue = FilterKey extends TypeKey
    ? ExperienceType
    : FilterKey extends CategoryKey
      ? ExperienceCategory
      : FilterKey extends TimeKey
        ? TimeFilter
        : FilterKey extends ModeKey
          ? ExperienceMode
          : FilterKey extends LocalityKey
            ? string
            : FilterKey extends TagKey
              ? string
              : undefined;

  const router = useRouter();
  return useCallback(
    (value: FilterValue) => {
      if (!key) {
        return;
      }
      const url = new URL(window.location.href);
      const urlParams = new URLSearchParams(url.search);
      if (!key === undefined) {
        urlParams.delete(key);
      }
      if (!value) {
        urlParams.delete(key);
      } else {
        urlParams.set(key, value);
      }
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      router.push(newUrl);
    },
    [key, router],
  );
};

export default useSetFilter;
